module.exports = __webpack_public_path__ + "images/notice.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notice.png
// module id = 960
// module chunks = 2